import React, { useState, useEffect, useRef } from "react";
import { useAuth, PLATFORM_OWNER_UID } from "./contexts/AuthContext";
import { OrgProvider } from "./contexts/OrgContext";
import { FeaturesProvider } from "./contexts/FeaturesContext";
import LoginPage from "./pages/LoginPage";
import DemoEntryPage from "./components/DemoEntryPage";
import DemoBanner from "./components/DemoBanner";
import OwnerDashboard from "./pages/OwnerDashboard";
import MyTasksPage from "./pages/MyTasksPage";
import OrgUsersPage from "./pages/OrgUsersPage";
import NewProjectModal from "./pages/NewProjectModal";
import ChatPage from "./pages/ChatPage";
import ControlCenter from "./pages/ControlCenter";
import ClientiPage from "./pages/ClientiPage";
import ImpiantiPage from "./pages/ImpiantiPage";
import RegistroCommessePage from "./pages/RegistroCommessePage";
import RegistroFatturazionePage from "./pages/RegistroFatturazionePage";
import StrumentiTecniciPage from "./pages/StrumentiTecniciPage";
import CentroControlloEvolutoPage from "./pages/CentroControlloEvolutoPage";
import MagazzinoPage from "./pages/MagazzinoPage";
import OrdiniMaterialiPage from "./pages/OrdiniMaterialiPage";
import RichiediNFPage from "./pages/RichiediNFPage";
import RientroMaterialiPage from "./pages/RientroMaterialiPage";
import RegistroNoleggiPage from "./pages/RegistroNoleggiPage";
import DocumentiSubappaltatoriPage from "./pages/DocumentiSubappaltatoriPage";
import DitteEsternePage from "./pages/DitteEsternePage";
import { PraticheApertePage } from "./components/PraticheTab";
import RegistroRientriMaterialiPage from "./pages/RegistroRientriMaterialiPage";
import RegistroCaviPage from "./pages/RegistroCaviPage";
import ListinoMaterialiPage from "./pages/ListinoMaterialiPage";
import SegnalazioneClientePage from "./pages/SegnalazioneClientePage";
import RegistroSegnalazioniPage from "./pages/RegistroSegnalazioniPage";
import ContrattiManutenzionePage, { GestioneContrattiManutenzionePage } from "./pages/ContrattiManutenzionePage";
import ProgrammazioneSettimanalePage from "./pages/ProgrammazioneSettimanalePage";
import DipendentiPage from "./pages/DipendentiPage";
import CentroAcquistiPage from "./pages/CentroAcquistiPage";
import ScadenzarioPage from "./pages/ScadenzarioPage";
import AbilitazioniPage from "./pages/AbilitazioniPage";
import NotaSpesePage from "./pages/NotaSpesePage";
import PresenzePage from "./pages/PresenzePage";
import { ZonaObbligoPresenze } from "./components/ObbligoPresenze";
import { FinestraFormazione } from "./components/RichiestaFormazione";
import { FinestraAbbonamento, apriRichiestaAbbonamento } from "./components/RichiestaAbbonamento";
import PianificazioneTeamPage from "./pages/PianificazioneTeamPage";
import NexioraInsightPage from "./pages/NexioraInsightPage";
import ConfirmProvider from "./utils/ConfirmProvider";
import VerbaliPage from "./pages/VerbaliPage";
import RegistroRapportiniPage from "./pages/RegistroRapportiniPage";
import MioCalendarioPage from "./pages/MioCalendarioPage";
import RegistroNotePage from "./pages/RegistroNotePage";
import MieBozzePage from "./pages/MieBozzePage";
import MieOrePage from "./pages/MieOrePage";
import PillolaOre from "./components/PillolaOre";
import { useUsaDiario } from "./hooks/useUsaDiario";
import NovitaNexiora from "./components/NovitaNexiora";
import RegistroInterventiPage from "./pages/RegistroInterventiPage";
import RegistroRichiesteCommPage from "./pages/RegistroRichiesteCommPage";
import NuovaRichiestaPotenzialeClientePage from "./pages/NuovaRichiestaPotenzialeClientePage";
import SopralluoghiSenzaCommessaPage from "./pages/SopralluoghiSenzaCommessaPage";
import ElaborazioneOffertaTab from "./components/ElaborazioneOffertaTab";
import RegistroSALPage from "./pages/RegistroSALPage";
import CruscottoScadenzePage from "./pages/CruscottoScadenzePage";
import IlTuoAnnoPage from "./pages/IlTuoAnnoPage";
import LeMieCommessePage from "./pages/LeMieCommessePage";
import ParcoMezziPage from "./pages/ParcoMezziPage";
import DisponibilitaMezziPanel from "./components/DisponibilitaMezziPanel";
import RegistroDDTPage from "./pages/RegistroDDTPage";
import RegistroDDTIngressoPage from "./pages/RegistroDDTIngressoPage";
import RegistroCorrispondenzaPage from "./pages/RegistroCorrispondenzaPage";
import RegistroSopralluoghiPage from "./pages/RegistroSopralluoghiPage";
import ImpostazioniOrgPage from "./pages/ImpostazioniOrgPage";
import { HomePage, NotificationsPage, SettingsPage } from "./pages/OtherPages";
import PivaObbligatoria from "./components/PivaObbligatoria";
import VerificaEmail from "./components/VerificaEmail";
import Sidebar from "./components/Sidebar";
import ProjectView from "./components/ProjectView";
import MiaArea from "./components/MiaArea";
import QuickActions from "./components/QuickActions";
import Nexi from "./components/Nexi";
import OnboardingModal from "./components/OnboardingModal";
import GuidaNexiora from "./components/GuidaNexiora";
import BannerPrimaVolta from "./components/BannerPrimaVolta";
import PromemoriaNoleggi from "./components/PromemoriaNoleggi";
import ReportOrePage from "./pages/ReportOrePage";
import ApprovazioneCartelliniPage from "./pages/ApprovazioneCartelliniPage";
import ApprovazioneNoteSpesePage from "./pages/ApprovazioneNoteSpesePage";
import RichiestaFeriePage from "./pages/RichiestaFeriePage";
import ApprovazioneFeriePermessiPage from "./pages/ApprovazioneFeriePermessiPage";
import useNotifications, { notificheConfigurate } from "./hooks/useNotifications";
import EntityDrawer from "./components/EntityDrawer";
import { NavProvider } from "./contexts/NavContext";
import { collection, query, where, onSnapshot, doc, getDoc, getDocs, addDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import { differenceInDays, parseISO } from "date-fns";
import { toLocalDateStr } from "./utils/dateUtils";
import { LISTINO, euro, preventivo } from "./utils/pianiNexiora";
import { useFornitore, urlLegali } from "./utils/fornitore";
import ZonaModulo from "./components/ZonaModulo";
import { PAGINA_MODULO } from "./utils/pianiNexiora";
import { statoSalvato, statoValido, annota, vocePerNavigazione, togliParametri } from "./utils/statoNavigazione";
import { attivitaAttiva } from "./utils/taskHelpers";

function AppLayout({ forcedOrgId, onBackToOwner }) {
  const { currentUser, userProfile, isOrgAdmin, isPlatformOwner: isPO, isTrialScaduto, isTrialAttivo, isReadOnly: orgInSolaLettura, giorniTrialRimanenti, organizationId: myOrgIdApp } = useAuth();
  const fornitore = useFornitore();
  // Riapertura dove si era (utils/statoNavigazione.js): se il telefono ha chiuso e
  // ricaricato la pagina, si riparte dalla schermata annotata nella cronologia.
  const orgAttiva = forcedOrgId || null;
  const [avvio] = useState(() => {
    const s = statoSalvato(currentUser?.uid);
    if (!s || s.owner || (s.org || null) !== orgAttiva || !s.page) return null;
    if (s.page === "project" && !s.projectId) return null;
    return s;
  });
  const [page, setPage] = useState(() => avvio?.page || "home");
  const [currentProject, setCurrentProject] = useState(() => avvio?.page === "project" ? { id: avvio.projectId } : null);
  const [showNewProject, setShowNewProject] = useState(false);
  const [sidebarMobileAperta, setSidebarMobileAperta] = useState(false);
  const [newProjectParent, setNewProjectParent] = useState(null);
  const [newProjectPrefill, setNewProjectPrefill] = useState(null);
  const [notifCountAttivita, setNotifCountAttivita] = useState(0);
  const [notifCountMessaggi, setNotifCountMessaggi] = useState(0);
  const notifCount = notifCountAttivita + notifCountMessaggi;
  const [showMiaArea, setShowMiaArea] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showGuida, setShowGuida] = useState(false);
  const [showNotifBanner, setShowNotifBanner] = useState(false);
  const { permesso, richiediPermesso } = useNotifications(currentUser);
  // «Le mie ore» e la pillola solo per i Non operativi con scheda collegata (W434):
  // se la pillola si vede, le ore vanno nei costi delle commesse. null = non ancora noto.
  const usaLeMieOre = useUsaDiario(myOrgIdApp, currentUser?.uid);

  // Mostra banner notifiche dopo 30 secondi se permesso non ancora dato
  useEffect(() => {
    if (!currentUser) return;
    const timer = setTimeout(() => {
      if (notificheConfigurate() && typeof Notification !== "undefined" && Notification.permission === "default") setShowNotifBanner(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, [currentUser]);

  // Controlla se onboarding già completato
  useEffect(()=>{
    if(!currentUser?.uid) return;
    getDoc(doc(db,"onboarding",currentUser.uid)).then(snap=>{
      if(!snap.exists()||!snap.data()?.completato) setShowOnboarding(true);
    });
    // Ascolta evento "Come iniziare" dalla sidebar
    const handler = ()=>setShowOnboarding(true);
    window.addEventListener("nexiora:onboarding",handler);
    // Ascolta evento "Guida" — la sidebar apre questa quando l'onboarding è già stato fatto
    const handlerGuida = ()=>setShowGuida(true);
    window.addEventListener("nexiora:guida",handlerGuida);
    return()=>{
      window.removeEventListener("nexiora:onboarding",handler);
      window.removeEventListener("nexiora:guida",handlerGuida);
    };
  },[currentUser?.uid]);

  // Ascolta evento "Trasforma in Commessa" dal simulatore
  useEffect(()=>{
    const handler = () => {
      const raw = sessionStorage.getItem("nexiora_sim_prefill");
      if(raw){ try{ setNewProjectPrefill(JSON.parse(raw)); sessionStorage.removeItem("nexiora_sim_prefill"); }catch{} }
      setShowNewProject(true);
    };
    window.addEventListener("nexiora:nuova-commessa", handler);
    return ()=>window.removeEventListener("nexiora:nuova-commessa", handler);
  },[]);

  const [projectHealthMap, setProjectHealthMap] = useState({});

  useEffect(() => {
    // FIX 09/09: mancava il controllo sull'organizzazione, presente invece nell'effetto
    // gemello poco sotto (calcolo salute commesse). Per un utente appena registrato,
    // currentUser diventa disponibile un istante prima di myOrgIdApp (due letture Firestore
    // separate e in sequenza dentro fetchUserProfile) — in quella finestra questo effetto
    // partiva comunque, mandando a Firestore where("organizationId","==",undefined), che le
    // regole non c'entrano affatto: è proprio l'SDK a rifiutare la query prima di
    // interrogare il server, con un errore non gestito che mandava in crash l'intera app
    // subito dopo la registrazione.
    if (!currentUser || !(forcedOrgId || myOrgIdApp)) return;
    const q = query(
      collection(db, "tasks"),
      where("assignedTo", "==", currentUser.uid),
      where("organizationId", "==", forcedOrgId || myOrgIdApp)
    );
    return onSnapshot(q, snap => {
      const today = new Date();
      const todayStr = toLocalDateStr(today);
      let count = 0;
      snap.docs.forEach(d => {
        const t = d.data();
        if (!attivitaAttiva(t)) return; // W452: annullate e sospese non sono «in scadenza»
        if (!t.dueDate) return;
        const days = differenceInDays(parseISO(t.dueDate), today);
        if (t.dueDate < todayStr) count++;
        else if (t.reminderEnabled && days <= (t.reminderDays || 1)) count++;
        else if (days <= 3) count++;
      });
      setNotifCountAttivita(count);
    });
  }, [currentUser, forcedOrgId, myOrgIdApp]);

  // Messaggi non letti della collezione "notifiche" (commenti, condivisioni, assegnazioni, avvisi):
  // contano nella campanella insieme alle attività in scadenza.
  useEffect(() => {
    if (!currentUser || !(forcedOrgId || myOrgIdApp)) return;
    const q = query(collection(db, "notifiche"),
      where("userId", "==", currentUser.uid), where("orgId", "==", forcedOrgId || myOrgIdApp));
    return onSnapshot(q, snap => setNotifCountMessaggi(snap.docs.filter(d => d.data().letta !== true).length),
      err => { console.warn("Notifiche non lette non disponibili:", err?.code || err); setNotifCountMessaggi(0); });
  }, [currentUser, forcedOrgId, myOrgIdApp]);

  // Calcola stato salute per ogni commessa (per colori sidebar)
  // "critical" = ha task scadute, "warning" = task in scadenza 3gg, "ok" = nessun problema
  useEffect(() => {
    if (!currentUser || !(forcedOrgId || myOrgIdApp)) return;
    // Scopata alla propria organizzazione: prima interrogava TUTTE le task di TUTTE le
    // organizzazioni senza filtro, oltre a rischiare l'indice composito con "status!=".
    const q = query(collection(db,"tasks"), where("organizationId","==",forcedOrgId || myOrgIdApp));
    return onSnapshot(q, snap => {
      const today = new Date();
      const todayStr = toLocalDateStr(today);
      const map = {};
      snap.docs.forEach(d => {
        const t = d.data();
        if (!attivitaAttiva(t)) return;
        if (!t.projectId || !t.dueDate) return;
        const curr = map[t.projectId] || "ok";
        if (t.dueDate < todayStr) {
          map[t.projectId] = "critical";
        } else if (curr !== "critical" && differenceInDays(parseISO(t.dueDate), today) <= 3) {
          map[t.projectId] = "warning";
        }
      });
      setProjectHealthMap(map);
    });
    // anche forcedOrgId: entrando in un'altra azienda (Platform Owner) i colori si rifanno (W416)
  }, [currentUser, myOrgIdApp, forcedOrgId]);

  const [deepLinkTarget, setDeepLinkTarget] = useState(() =>
    avvio && (avvio.clienteId || avvio.dipId || avvio.projectId || avvio.eoId || avvio.elenco || avvio.filtroStato) ? avvio : null);
  // Sale a ogni clic di navigazione — usato come "key" sulle pagine condivise da più voci
  // di sidebar (es. Elaborazione Offerte e Registro Offerte puntano alla stessa pagina),
  // così cliccarci sopra ricomincia sempre da capo, anche se non si sta "cambiando pagina"
  // in senso stretto.
  const [navKey, setNavKey] = useState(0);
  const [currentProjectInitialTab, setCurrentProjectInitialTab] = useState(() => avvio?.page === "project" ? (avvio.initialTab || null) : null);
  const [newProjectOrigineEo, setNewProjectOrigineEo] = useState(null); // {eoId} — per ricollegare l'offerta dopo la creazione

  const [attivitaDaAprire, setAttivitaDaAprire] = useState(null); // attività da aprire dentro la commessa (link dalle email)
  // «Le mie ore» è a tutto schermo: «Esci» riporta alla schermata da cui si era entrati
  const primaDelleOreRef = useRef(null);
  const handleNavigate = newNav => {
    if (newNav?.page === "le-mie-ore" && page !== "le-mie-ore")
      primaDelleOreRef.current = page === "project" && currentProject?.id ? { page: "project", projectId: currentProject.id } : { page };
    setAttivitaDaAprire(newNav?.page === "project" ? (newNav.taskId || null) : null);
    if (newNav.page === "new-project") {
      setNewProjectParent(newNav.parentId ? { parentId:newNav.parentId, clienteNome:newNav.clienteNome } : null);
      setShowNewProject(true);
      return;
    }
    // La commessa nasce da un'offerta finalizzata — trovo o creo la cartella del cliente
    // (stessa logica già in NewProjectModal, qui replicata perché serve prima di aprire il
    // form vero), poi apro il form pronto con nome/note già suggeriti dall'offerta.
    if (newNav.page === "crea-commessa-da-offerta") {
      (async () => {
        const snap = await getDocs(query(collection(db,"projects"),
          where("organizationId","==",myOrgIdApp),
          where("clienteId","==",newNav.clienteId),
          where("isParent","==",true)));
        let parentId, clienteNomeRisolto = newNav.clienteNome;
        if (!snap.empty) {
          parentId = snap.docs[0].id;
          clienteNomeRisolto = snap.docs[0].data().clienteNome || newNav.clienteNome;
        } else {
          const ref = await addDoc(collection(db,"projects"), {
            name: newNav.clienteNome, clienteId: newNav.clienteId, clienteNome: newNav.clienteNome,
            isParent: true, color: "#7c3aed", organizationId: myOrgIdApp,
            createdBy: currentUser?.uid, createdAt: serverTimestamp(), archived: false,
          });
          parentId = ref.id;
        }
        setNewProjectParent({ parentId, clienteNome: clienteNomeRisolto });
        setNewProjectPrefill({ nome: newNav.oggettoOfferta || "", sitoCliente: newNav.sitoCliente || "", sede: newNav.sede || null });
        setNewProjectOrigineEo({ eoId: newNav.eoId });
        setShowNewProject(true);
      })();
      return;
    }
    // Si può aprire una commessa anche solo con il suo id (registri, avvisi): i dati li
    // carica la commessa stessa. Prima finiva sulla Home.
    if (newNav.page === "project" && (newNav.project || newNav.projectId)) {
      setCurrentProject(newNav.project || { id: newNav.projectId });
      setCurrentProjectInitialTab(newNav.initialTab || null);
    }
    // Navigazione con deep link (es. da drawer → clienteId specifico)
    if (newNav.clienteId || newNav.dipId || newNav.projectId || newNav.eoId || newNav.elenco || newNav.filtroStato || newNav.segId) {
      setDeepLinkTarget(newNav);
    } else {
      setDeepLinkTarget(null);
    }
    setPage(newNav.page);
    setNavKey(k => k+1);
    // un passo nella cronologia (tasto «indietro»), tranne quando è proprio il tasto
    // «indietro» a riportarci qui
    if (!daCronologiaRef.current) annota(currentUser?.uid, orgAttiva, vocePerNavigazione(newNav));
  };
  const daCronologiaRef = useRef(false);

  // Prima schermata della sessione: la si annota (senza aggiungere passi), così il tasto
  // «indietro» può tornarci.
  useEffect(() => {
    if (!avvio) annota(currentUser?.uid, orgAttiva, { page: "home" }, false);
  }, [avvio, currentUser?.uid, orgAttiva]);

  // Il navigatore più recente, per gli ascoltatori che restano attivi (link, notifiche, «indietro»)
  const navigaRef = useRef(null);
  navigaRef.current = handleNavigate;

  // Link dalle email (functions/emailCommessa.js): ?commessa=<id>&attivita=<id>&scheda=<tab>
  // apre direttamente la commessa (e l'attività o la scheda indicata). Si legge una volta
  // sola, poi si toglie dall'indirizzo così un aggiornamento della pagina non lo ripete.
  // (si legge una volta per utente: handleNavigate passa da navigaRef, qui sotto, sempre l'ultimo)
  const uidLink = currentUser?.uid;
  useEffect(() => {
    if (!uidLink) return;
    try {
      const qs = new URLSearchParams(window.location.search);
      // scorciatoia dell'app installata (tenendo premuta l'icona): «Segna le ore»
      if (qs.get("apri") === "le-mie-ore") { navigaRef.current({ page: "le-mie-ore" }); togliParametri(["apri"]); return; }
      const commessa = qs.get("commessa");
      if (!commessa) return;
      navigaRef.current({ page: "project", projectId: commessa, initialTab: qs.get("scheda") || null, taskId: qs.get("attivita") || null });
      togliParametri(["commessa", "attivita", "scheda"]);
    } catch { /* indirizzo non leggibile: si apre la Home come sempre */ }
  }, [uidLink]);

  // Clic su una notifica sul dispositivo (Nexiora già aperta): il service worker delle
  // notifiche manda l'indirizzo (stesso formato dei link delle email) e si apre lì.

  // Tasto «indietro» (o «avanti») del telefono/browser: si torna alla schermata annotata.
  // Il passaggio tra elenco aziende e azienda del titolare della piattaforma lo gestisce App.
  useEffect(() => {
    const onPop = (e) => {
      const s = statoValido(e.state, currentUser?.uid);
      if (!s || s.owner || (s.org || null) !== orgAttiva || !s.page) return;
      if (s.page === "project" && !s.projectId) return;
      daCronologiaRef.current = true;
      try { navigaRef.current({ ...s }); } finally { daCronologiaRef.current = false; }
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [currentUser?.uid, orgAttiva]);
  useEffect(() => {
    const apriLink = (url) => {
      const handleNavigate = navigaRef.current;
      try {
        const qs = new URL(url, window.location.origin).searchParams;
        const commessa = qs.get("commessa");
        if (commessa) handleNavigate({ page: "project", projectId: commessa, initialTab: qs.get("scheda") || null, taskId: qs.get("attivita") || null });
        else handleNavigate({ page: "notifications" });
      } catch { /* indirizzo non leggibile */ }
    };
    const daSw = (e) => { if (e.data?.type === "NOTIFICATION_CLICK" && e.data.url) apriLink(e.data.url); };
    const daPagina = (e) => { if (e.detail) apriLink(e.detail); };
    if ("serviceWorker" in navigator) navigator.serviceWorker.addEventListener("message", daSw);
    window.addEventListener("nexiora:apri-link", daPagina);
    return () => {
      if ("serviceWorker" in navigator) navigator.serviceWorker.removeEventListener("message", daSw);
      window.removeEventListener("nexiora:apri-link", daPagina);
    };
  }, []);

  const renderPage = () => {
    switch (page) {
      case "home": return <HomePage onNavigate={handleNavigate}/>;
      case "my-tasks": return <MyTasksPage onNavigate={handleNavigate}/>;
      case "notifications": return <NotificationsPage onNavigate={handleNavigate}/>;
      case "chat": return <ChatPage/>;
      case "control-center": return <ControlCenter onNavigate={handleNavigate} deepLink={deepLinkTarget}/>;
      case "report-ore": return <ReportOrePage onNavigate={handleNavigate}/>;
      case "approvazione-cartellini": return <ApprovazioneCartelliniPage/>;
      case "approvazione-note-spese": return <ApprovazioneNoteSpesePage/>;
      case "richiesta-ferie": return <RichiestaFeriePage/>;
      case "approvazione-ferie-permessi": return <ApprovazioneFeriePermessiPage/>;
      case "clienti": return <ClientiPage deepLink={deepLinkTarget} onNavigate={handleNavigate}/>;
      case "impianti": return <ImpiantiPage onNavigate={handleNavigate}/>;
      case "registro-commesse": return <RegistroCommessePage onNavigate={handleNavigate}/>;
      case "da-fatturare": return <RegistroFatturazionePage onNavigate={handleNavigate} deepLink={deepLinkTarget}/>;
      case "strumenti-tecnici": return <StrumentiTecniciPage/>;
      case "centro-evoluto": return <CentroControlloEvolutoPage/>;
      case "magazzino": return <MagazzinoPage onNavigate={handleNavigate}/>;
      case "ordini-materiali": return <OrdiniMaterialiPage/>;
      case "richiedi-nf": return <RichiediNFPage/>;
      case "rientro-materiali": return <RientroMaterialiPage/>;
      case "registro-noleggi": return <RegistroNoleggiPage onNavigate={handleNavigate}/>;
      case "documenti-subappaltatori": return <DocumentiSubappaltatoriPage/>;
      case "ditte-esterne": return <DitteEsternePage onNavigate={handleNavigate}/>;
      case "pratiche-aperte": return <PraticheApertePage/>;
      case "registro-rientri-materiali": return <RegistroRientriMaterialiPage deepLink={deepLinkTarget}/>;
      case "registro-cavi": return <RegistroCaviPage onNavigate={handleNavigate}/>;
      case "listino-materiali": return <ListinoMaterialiPage/>;
      case "segnalazioni-cliente": return <SegnalazioneClientePage onNavigate={handleNavigate} deepLink={deepLinkTarget}/>;
      case "registro-segnalazioni": return <RegistroSegnalazioniPage deepLink={deepLinkTarget}/>;
      case "contratti-manutenzione": return <ContrattiManutenzionePage/>;
      case "gestione-contratti-manutenzione": return <GestioneContrattiManutenzionePage/>;
      case "programmazione": return <ProgrammazioneSettimanalePage/>;
      case "dipendenti": return <DipendentiPage deepLink={deepLinkTarget} onNavigate={handleNavigate}/>;
      case "centro-acquisti": return <CentroAcquistiPage/>;
      case "scadenziario": return <ScadenzarioPage onNavigate={handleNavigate}/>;
      case "abilitazioni": return <AbilitazioniPage/>;
      case "nota-spese": return <NotaSpesePage onNavigate={handleNavigate}/>;
      case "nexiora-insight": return <NexioraInsightPage onNavigate={handleNavigate}/>;
      case "presenze": return <PresenzePage onNavigate={handleNavigate}/>;
      case "pianificazione-team": return <PianificazioneTeamPage onNavigate={handleNavigate}/>;
      case "verbali": return <VerbaliPage/>;
      case "registro-rapportini": return <RegistroRapportiniPage/>;
      case "mio-calendario": return <MioCalendarioPage onNavigate={handleNavigate}/>;
      case "registro-note": return <RegistroNotePage onNavigate={handleNavigate}/>;
      case "le-mie-bozze": return <MieBozzePage onNavigate={handleNavigate}/>;
      // a tutto schermo; «Esci» torna alla schermata da cui si era entrati
      case "le-mie-ore": return usaLeMieOre === null ? null : usaLeMieOre
        ? <MieOrePage onEsci={() => handleNavigate(primaDelleOreRef.current || { page: "home" })}/>
        : <LeMieOreNonDisponibile onEsci={() => handleNavigate({ page: "home" })}/>;
      case "registro-interventi": return <RegistroInterventiPage onNavigate={handleNavigate}/>;
      case "registro-richieste-comm": return <RegistroRichiesteCommPage onNavigate={handleNavigate}/>;
      case "nuova-richiesta-potenziale": return <NuovaRichiestaPotenzialeClientePage onNavigate={handleNavigate}/>;
      case "sopralluoghi-senza-commessa": return <SopralluoghiSenzaCommessaPage onNavigate={handleNavigate}/>;
      case "elaborazione-offerte": return <ElaborazioneOffertaTab key={navKey} deepLink={deepLinkTarget} onNavigate={handleNavigate}/>;
      case "registro-sal": return <RegistroSALPage onNavigate={handleNavigate}/>;
      case "cruscotto-scadenze": return <CruscottoScadenzePage onNavigate={handleNavigate}/>;
      case "il-tuo-anno": return <IlTuoAnnoPage onNavigate={handleNavigate}/>;
      case "le-mie-commesse": return <LeMieCommessePage onNavigate={handleNavigate}/>;
      case "parco-mezzi": return <ParcoMezziPage onNavigate={handleNavigate}/>;
      case "disponibilita-mezzi": return <DisponibilitaMezziPanel onNavigate={handleNavigate}/>;
      case "registro-ddt": return <RegistroDDTPage onNavigate={handleNavigate}/>;
      case "registro-ddt-ingresso": return <RegistroDDTIngressoPage onNavigate={handleNavigate}/>;
      case "registro-corrispondenza": return <RegistroCorrispondenzaPage/>;
      case "registro-sopralluoghi": return <RegistroSopralluoghiPage onNavigate={handleNavigate}/>;
      case "impostazioni-org": return <ImpostazioniOrgPage/>;
      case "users": return <OrgUsersPage/>;
      case "settings": return <SettingsPage/>;
      case "project":
        return currentProject
          ? <ProjectView key={currentProject.id} project={currentProject} initialTab={currentProjectInitialTab} initialTaskId={attivitaDaAprire} onNavigate={handleNavigate}/>
          : <HomePage onNavigate={handleNavigate}/>;
      default: return <HomePage onNavigate={handleNavigate}/>;
    }
  };

  return (
    // OrgProvider wrap — tutti i componenti figli leggono effectiveOrgId dal context
    <OrgProvider forcedOrgId={forcedOrgId}>
      <FeaturesProvider>
      <NavProvider onNavigate={handleNavigate}>
      <div className="app" style={{display:"flex", flexDirection:"column", height:"100vh"}}>
        {userProfile?.isDemoVisitor && <DemoBanner/>}
        {!userProfile?.isDemoVisitor && <PivaObbligatoria/>}
        {!userProfile?.isDemoVisitor && <VerificaEmail/>}
        <div style={{display:"flex", flex:1, minHeight:0}}>
        <button className="mobile-nav-toggle" onClick={()=>setSidebarMobileAperta(true)} aria-label="Apri menu">
          <span style={{fontSize:20,lineHeight:1}}>☰</span>
        </button>
        <div className={`mobile-sidebar-wrapper${sidebarMobileAperta?" aperto":""}`} style={{display:"contents"}}>
        {sidebarMobileAperta && (
          <button className="mobile-nav-close" onClick={()=>setSidebarMobileAperta(false)} aria-label="Chiudi menu">
            <span style={{fontSize:18,lineHeight:1}}>✕</span>
          </button>
        )}
        <Sidebar
          vediLeMieOre={usaLeMieOre === true}
          currentPage={page}
          currentProjectId={currentProject?.id}
          onNavigate={(nav)=>{ setSidebarMobileAperta(false); handleNavigate(nav); }}
          notifCount={notifCount}
          onBackToOwner={onBackToOwner}
          projectHealthMap={projectHealthMap}
        />
        </div>
        <div className="main" style={{ overflow:"hidden", position:"relative", display:"flex", flexDirection:"column" }}>
          {/* Banner trial */}
          {!isPO && isTrialAttivo && giorniTrialRimanenti !== null && giorniTrialRimanenti <= 14 && (
            <div style={{background:"#fef3c7",borderBottom:"1px solid #fde68a",padding:"6px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:12,color:"#92400e",flexShrink:0}}>
              <span>⏳ La prova gratuita (tutti i moduli, anche Gold) termina tra <strong>{giorniTrialRimanenti} {giorniTrialRimanenti===1?"giorno":"giorni"}</strong>. Poi serve il piano Pro o Gold, da {euro(preventivo(1,"pro").mensile)}/mese fino a {LISTINO.bloccoPosti} utenti. Senza piano Nexiora resta consultabile in sola lettura.</span>
              <a href={urlLegali(fornitore).prezzi} target="_blank" rel="noreferrer" style={{fontSize:11,fontWeight:700,color:"#92400e"}}>Vedi i piani →</a>
            </div>
          )}
          {!isPO && isTrialScaduto && (
            <div style={{background:"#fee2e2",borderBottom:"1px solid #fca5a5",padding:"8px 20px",display:"flex",alignItems:"center",justifyContent:"space-between",fontSize:12,color:"#dc2626",flexShrink:0}}>
              <span>🔒 Prova terminata: Nexiora è in sola lettura. Attiva il piano Pro o Gold per riprendere a lavorare: i tuoi dati sono al sicuro, consultabili ed esportabili.</span>
              {isOrgAdmin
                ? <button type="button" onClick={apriRichiestaAbbonamento} style={{fontSize:11,fontWeight:700,color:"#dc2626",border:"1px solid #fca5a5",padding:"3px 10px",borderRadius:6,background:"#fff",whiteSpace:"nowrap",cursor:"pointer",fontFamily:"inherit"}}>Attiva il piano →</button>
                : <a href={urlLegali(fornitore).prezzi} target="_blank" rel="noreferrer" style={{fontSize:11,fontWeight:700,color:"#dc2626",textDecoration:"none",border:"1px solid #fca5a5",padding:"3px 10px",borderRadius:6,background:"#fff",whiteSpace:"nowrap"}}>Piani e prezzi →</a>}
            </div>
          )}
          {/* Avatar pulsante in alto a destra */}
          {(()=>{
            const nome = currentUser?.displayName||currentUser?.email||"?";
            const iniziali = nome.split(" ").map(p=>p[0]).join("").substring(0,2).toUpperCase();
            return (
              <button onClick={()=>setShowMiaArea(s=>!s)}
                title="La mia area"
                style={{position:"absolute",top:12,right:16,zIndex:100,width:36,height:36,borderRadius:"50%",background:"linear-gradient(135deg,#7c3aed,#3730a3)",border:"2px solid #fff",cursor:"pointer",color:"#fff",fontSize:13,fontWeight:800,fontFamily:"'Inter',sans-serif",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 2px 8px rgba(124,58,237,.4)"}}>
                {iniziali}
              </button>
            );
          })()}
          <BannerPrimaVolta sezioneId={page}/>
          {!userProfile?.isDemoVisitor && <PromemoriaNoleggi/>}
          <ZonaModulo modulo={PAGINA_MODULO[page]} escludiBloccoTotale={["users","impostazioni-org","settings"].includes(page)}>
            {/* W419: cartellino obbligatorio — i giorni da mettere in regola prima del resto */}
            <ZonaObbligoPresenze page={page} onNavigate={handleNavigate}>{renderPage()}</ZonaObbligoPresenze>
          </ZonaModulo>
        </div>
        </div>
        {showNewProject && (
          <NewProjectModal
            onClose={() => { setShowNewProject(false); setNewProjectParent(null); setNewProjectPrefill(null); }}
            onNavigate={handleNavigate}
            parentId={newProjectParent?.parentId}
            clienteNome={newProjectParent?.clienteNome}
            prefill={newProjectPrefill}
            onCreated={async p => {
              if (newProjectOrigineEo?.eoId) {
                try {
                  await updateDoc(doc(db,"elaborazioniOfferte",newProjectOrigineEo.eoId), {
                    projectIdCollegato: p.id, projectNomeCollegato: p.name||"", updatedAt: serverTimestamp(),
                  });
                } catch (err) { console.error("Errore ricollegamento offerta→commessa:", err); }
              }
              if(!p.isParent){ setCurrentProject(p); setPage("project"); annota(currentUser?.uid, orgAttiva, { page: "project", projectId: p.id }); }
              setShowNewProject(false); setNewProjectParent(null); setNewProjectPrefill(null); setNewProjectOrigineEo(null);
            }}
          />
        )}
        {showMiaArea && (
          <MiaArea onNavigate={handleNavigate} onClose={()=>setShowMiaArea(false)}/>
        )}
        {/* W426: «Richiedi formazione», aperta da La mia area, Impostazioni, Utenti e Nexi */}
        {!userProfile?.isDemoVisitor && <FinestraFormazione/>}
        {/* W431: «Attiva il piano», aperta da Utenti e dalla barra di fine prova */}
        {!userProfile?.isDemoVisitor && <FinestraAbbonamento/>}
        <QuickActions onNavigate={handleNavigate}/>
        {usaLeMieOre === true && page !== "le-mie-ore" && !userProfile?.isDemoVisitor && <PillolaOre onApri={() => handleNavigate({ page: "le-mie-ore" })}/>}
        <Nexi pagina={page} onNavigate={handleNavigate} nascosto={showGuida || (showNotifBanner && permesso === "default")}/>
        {showNotifBanner && permesso === "default" && (
          <div style={{
            position:"fixed", bottom:80, right:20, zIndex:999,
            background:"#1e1b4b", color:"#fff", borderRadius:12,
            padding:"16px 20px", maxWidth:320, boxShadow:"0 8px 32px rgba(0,0,0,0.3)",
            animation:"slideUp 0.3s ease",
          }}>
            <div style={{fontSize:14,fontWeight:700,marginBottom:6}}>🔔 Attiva le notifiche</div>
            <div style={{fontSize:12,color:"#c4b5fd",lineHeight:1.5,marginBottom:12}}>
              Ricevi avvisi anche quando Nexiora è chiusa — scadenze, approvazioni, aggiornamenti.
            </div>
            <div style={{display:"flex",gap:8}}>
              <button onClick={async()=>{ await richiediPermesso(); setShowNotifBanner(false); }}
                style={{flex:1,padding:"7px",background:"#7c3aed",border:"none",borderRadius:7,
                  color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                Attiva
              </button>
              <button onClick={()=>setShowNotifBanner(false)}
                style={{padding:"7px 10px",background:"transparent",border:"1px solid rgba(255,255,255,0.2)",
                  borderRadius:7,color:"rgba(255,255,255,0.6)",fontSize:12,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
                Dopo
              </button>
            </div>
          </div>
        )}
        {showOnboarding && <OnboardingModal onClose={()=>setShowOnboarding(false)}/>}
        {showGuida && <GuidaNexiora onClose={()=>setShowGuida(false)} onNavigate={handleNavigate}/>}
        {/* «Cosa c'è di nuovo», una volta per dispositivo dopo un aggiornamento (utils/novita.js) */}
        <NovitaNexiora onNavigate={handleNavigate} nascosto={showOnboarding || showGuida}/>
        <EntityDrawer/>
      </div>
      </NavProvider>
      </FeaturesProvider>
    </OrgProvider>
  );
}

export default function App() {
  const { currentUser, isPlatformOwner } = useAuth();
  // Titolare della piattaforma: dopo una ricarica si rientra nell'azienda che era aperta
  // (utils/statoNavigazione.js), e il tasto «indietro» passa tra azienda ed elenco aziende.
  const [viewMode, setViewMode] = useState(() => isPlatformOwner && statoSalvato(currentUser?.uid)?.org ? "app" : "auto");
  const [selectedOrg, setSelectedOrg] = useState(() => {
    const org = isPlatformOwner ? statoSalvato(currentUser?.uid)?.org : null;
    return org ? { id: org } : null;
  });

  const handleEnterOrg = org => { setSelectedOrg(org); setViewMode("app"); annota(currentUser?.uid, org.id, { page: "home" }); };
  const handleBackToOwner = () => { setViewMode("owner"); setSelectedOrg(null); annota(currentUser?.uid, null, { owner: true }); };

  const inElencoAziende = isPlatformOwner && viewMode !== "app";
  useEffect(() => {
    if (!inElencoAziende) return;
    const s = statoSalvato(currentUser?.uid);
    if (!s || !s.owner) annota(currentUser?.uid, null, { owner: true }, !!s);
  }, [inElencoAziende, currentUser?.uid]);
  useEffect(() => {
    if (!isPlatformOwner) return undefined;
    const onPop = (e) => {
      const s = statoValido(e.state, currentUser?.uid);
      if (!s) return;
      if (s.owner) { setViewMode("owner"); setSelectedOrg(null); }
      else if (s.org) { setSelectedOrg(o => (o?.id === s.org ? o : { id: s.org })); setViewMode("app"); }
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [isPlatformOwner, currentUser?.uid]);

  const ePercorsoDemo = window.location.pathname.replace(/\/+$/,"") === "/demo";
  if (!currentUser) return ePercorsoDemo ? <DemoEntryPage/> : <LoginPage/>;
  if (isPlatformOwner) {
    if (viewMode === "owner" || viewMode === "auto") return <OwnerDashboard onEnterOrg={handleEnterOrg}/>;
    if (viewMode === "app" && selectedOrg) return <AppLayout key={selectedOrg.id} forcedOrgId={selectedOrg.id} onBackToOwner={handleBackToOwner}/>;
  }
  return <AppLayout/>;
}

// «Le mie ore» aperta da un collegamento da chi non la usa (Operativi, account senza scheda)
function LeMieOreNonDisponibile({ onEsci }) {
  return (
    <div style={{ maxWidth: 520, margin: "60px auto", padding: "0 16px", fontFamily: "'Inter',sans-serif", textAlign: "center" }}>
      <div style={{ fontSize: 34 }}>⏱️</div>
      <h2 style={{ fontSize: 18, margin: "8px 0" }}>«Le mie ore» non è attiva per te</h2>
      <p style={{ fontSize: 14, color: "#4b5563", lineHeight: 1.5 }}>
        Serve al personale Non operativo (ufficio, PM, direzione) per segnare le ore sulle commesse.
        Si attiva da sola quando in Dipendenti &amp; Collaboratori la tua scheda è collegata al tuo account
        con Categoria operativa «Non operativo». Se pensi che debba esserlo, chiedi a chi gestisce il personale.
      </p>
      <button type="button" onClick={onEsci} style={{ marginTop: 10, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 8, padding: "9px 18px", fontSize: 14, cursor: "pointer", fontFamily: "inherit" }}>Torna alla Home</button>
    </div>
  );
}
